/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
Command: npx gltfjsx@6.5.3 iPad.glb -T 
Files: iPad.glb [1.45MB] > C:\Users\taten\OneDrive\Desktop\Big ones\Apple 3d\frontend\public\assets\iPad_Assets\iPad-transformed.glb [198.9KB] (86%)
*/

import React, { useEffect } from 'react'
import { useGLTF } from '@react-three/drei'
import { noChangePartsiPad } from '../constants'
import * as THREE from 'three'
import useiPadStore from '../store'

export default function IPadModel(props) {

  const {color} = useiPadStore()

  const { nodes, materials, scene } = useGLTF('/assets/iPad_Assets/models/iPadReal1-transformed.glb')

  useEffect(() => {
    scene.traverse((child) => {
      if (child.isMesh) {
        // change only if the part name is not noChange parts
        if (!noChangePartsiPad.includes(child.name)) {
          child.material.color = new THREE.Color(color)
        }
      }
    })
  }, [color, scene])
  return (
    <group {...props} dispose={null}>
      <mesh geometry={nodes.Text.geometry} material={materials.PaletteMaterial001} />
      <mesh geometry={nodes.Face_sheet002.geometry} material={materials.PaletteMaterial002} />
      <mesh geometry={nodes.CameraandLight.geometry} material={materials['Material.003']} />
      <mesh geometry={nodes.Bexel.geometry} material={materials.PaletteMaterial003} />
      <mesh geometry={nodes.SelfiCamera.geometry} material={materials['Material.004']} />
      <mesh geometry={nodes.Screen.geometry} material={materials['Material.002']} />
      <mesh geometry={nodes.Apple_logo001.geometry} material={materials.Apple_logo} position={[0, -0.006, 0]} />
    </group>
  )
}

useGLTF.preload('/assets/iPad_Assets/models/iPadReal1-transformed.glb')
